import React from "react";
import { useTheme } from "../../hooks/useTheme";
import styles from "./PayWallModal.module.css";

interface PaywallModalProps {
  onOpenFullPaywall: () => void;
}

export const PaywallModal: React.FC<PaywallModalProps> = ({
  onOpenFullPaywall,
}) => {
  const { theme } = useTheme();

  return (
    <div className={styles.overlay}>
      <div
        className={`${styles.modal} ${
          theme === "dark" ? styles.dark : styles.light
        }`}
      >
        {/*  Заголовок  */}
        <h3 className={styles.title}>Не пропусти важное на дороге</h3>

        {/* Описание */}
        <p className={styles.description}>
          Смотри полную карту: посты ДПС, аварии и прочие события на дорогах с
          подпиской ДПС Premium
        </p>

        {/* Кнопка */}
        <button className={styles.subscribeButton} onClick={onOpenFullPaywall}>
          Оформить подписку
        </button>
      </div>
    </div>
  );
};
